import { render, staticRenderFns } from "./PageWebPaymentDelivery.vue?vue&type=template&id=1f74ff13"
import script from "./PageWebPaymentDelivery.vue?vue&type=script&lang=js"
export * from "./PageWebPaymentDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports